import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcModuleSubjectServer } from '../rpc-module-subject-server';
import { RpcExtensionBrokerRequest, RpcExtensionBrokerRequestKey } from './rpc-extension-broker-model';
import { RpcExtensionBrokerRequestHandler } from './rpc-extension-broker-request-handler';

/**
 * Rpc extension broker subject interface for module side
 */
export interface RpcExtensionBrokerModuleSubject extends Subject<DeferredData<RpcExtensionBrokerRequest, void>> {}

/**
 * The class to implement Rpc extension with Subject server for module side
 */
export class RpcExtensionBrokerModuleSubjectServer
        extends RpcModuleSubjectServer<RpcExtensionBrokerRequest, void>
        implements RpcExtensionBrokerRequestHandler {

    /**
     * Initializes a new instance of the RpcExtensionBrokerModuleSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcExtensionBrokerRequestKey.command);
    }

    /**
     * The handler to respond a request for Rpc extension call.
     *
     * @param data The extension object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcExtensionBrokerRequest): Promise<void> {
        return this.processNextForSubject(RpcExtensionBrokerRequestKey.command, data);
    }
}
